import RegisterAppSumo from './RegisterAppSumo';

export default RegisterAppSumo;
